import * as api from "../api/listService";

const listsCache = {
    value: null,
    promise: null,
};

export function clearListsCache() {
    listsCache.value = null;
    listsCache.promise = null;
}

export async function getLists(options = {}) {
    const { force = false } = options;
    if (!force && listsCache.value) {
        return listsCache.value;
    }
    if (!force && listsCache.promise) {
        return listsCache.promise;
    }
    const request = api
        .getLists()
        .then((response) => {
            listsCache.value = response;
            listsCache.promise = null;
            return response;
        })
        .catch((error) => {
            listsCache.promise = null;
            throw error;
        });
    listsCache.promise = request;
    return request;
}

export async function postList(request) {
    const resultPage = await api
        .postList(request)
    clearListsCache();
    return resultPage;
}

export async function deleteList(request) {
    const resultPage = await api
        .deleteList(request)
    clearListsCache();
    return resultPage;
}

export async function updateList(request) {
    const resultPage = await api
        .updateList(request)
    clearListsCache();
    return resultPage;
}

/* export async function syncListWithLinkedIn() {
    const resultPage = await api
        .syncListWithLinkedIn()
        return resultPage;
} */

export async function syncExclusionWithLinkedIn() {
    const resultPage = await api
        .syncExclusionWithLinkedIn()
        return resultPage;
}

export async function syncTargetAccountsWithLinkedIn() {
    const resultPage = await api
        .syncTargetAccountsWithLinkedIn()
        return resultPage;
}

export async function syncContactsWithLinkedIn(request = {}) {
    const resultPage = await api
        .syncContactsWithLinkedIn(request)
        return resultPage;
}

export async function syncContactsWithGoogleAds(request = {}) {
    const resultPage = await api
        .syncContactsWithGoogleAds(request)
    return resultPage;
}

export async function syncContactsWithMetaAds(request = {}) {
    const resultPage = await api
        .syncContactsWithMetaAds(request)
    return resultPage;
}

export async function getContactsSyncJobs() {
    return api.getContactsSyncJobs();
}
